/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class SMPColorMapAPI
 * @hideconstructor
 * @classdesc
 */
define([], () => {
	class SMPColorMapAPI {
		/**
		 * getKeyForUserPalette gets key for user palette
		 * @param labelArray - an array of 1 or more labels that make up a tuple (label value) to be coloured  eg: ['Canada'] or ['Canada', '2005']
		 * @param dataItem - an object containing data item information
		 * @returns combined key concept + color mapping
		 */
		getKeyForUserPalette() {}
		/**
		 * getUserColorMap gets user color map
		 * @returns user color map
		 */
		getUserColorMap() {}
		/**
		 * determines if this provider has applicable color map
		 * @returns boolean
		 */
		hasApplicableColorMap() {}
	}
	return SMPColorMapAPI;
});
